var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAmex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 33,
    viewBox: "0 0 52 33",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M47.887 0H4.11047C1.7812 0 0 1.78121 0 4.11048V28.7322C0 31.0615 1.91822 32.8427 4.11047 32.8427H47.887C50.2163 32.8427 51.9975 31.0615 51.9975 28.7322V4.09677C51.9838 1.7675 50.0656 0 47.887 0Z",
    fill: "#010202"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.887 1.37016C49.3942 1.37016 50.6273 2.60331 50.6273 4.11048V28.7322C50.6273 30.2394 49.3942 31.4725 47.887 31.4725H4.11043C2.60326 31.4725 1.37012 30.2394 1.37012 28.7322V4.09678C1.37012 2.5896 2.60326 1.35646 4.11043 1.35646H47.887",
    fill: "#286CB4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2767 14.0441L13.3317 16.6063H11.2216L12.2767 14.0441ZM34.2677 14.1537H30.1983V15.291H34.1992V16.99H30.1983V18.2505H34.2677V19.2644L37.1039 16.1953L34.2677 12.9891V14.1537ZM15.0307 10.9476H20.4976L21.7171 13.592L22.8406 10.9339H37.0217L38.5015 12.5644L40.0224 10.9339H46.5306L41.7214 16.209L46.4895 21.443H39.8717L38.3919 19.8125L36.8573 21.443H13.729L13.0577 19.8125H11.5094L10.838 21.443H5.49438L9.9885 10.9339H14.6744L15.0307 10.9476ZM26.8826 12.4273H23.8134L21.7582 17.264L19.5385 12.4273H16.4968V19.0041L13.6742 12.4273H10.9476L7.68664 19.9632H9.81038L10.4818 18.3327H14.0579L14.7292 19.9632H18.4561V14.5785L20.8539 19.9632H22.4843L24.8684 14.5922V19.9632H26.8689L26.8826 12.4273ZM39.6524 16.209L43.1189 12.4273H40.6252L38.433 14.784L36.3092 12.4273H28.2527V19.9769H36.1996L38.4056 17.5928L40.5293 19.9769H43.0915L39.6524 16.209Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmex);
export default __webpack_public_path__ + "static/media/amex.c15034b62e512700bffdd93d876b51ce.svg";
export { ForwardRef as ReactComponent };